import DefaultVehicleList from '../components/lists/DefaultVehicleList';
import { useDefaultVehicles } from '../hooks/apiHooks';
import Layout from '../layout';

const AdminVehicleTypesPage = ({ routes }) => {
  const { defaultVehicles } = useDefaultVehicles();

  return (
    <Layout
      showCarriersNavigation
      disableLoading={false}
      menuIndex={0}
      routes={routes}
    >
      <DefaultVehicleList id="vehicles" vehicles={defaultVehicles} />
    </Layout>
  );
};

export default AdminVehicleTypesPage;
